import axios from 'axios'

class Http {
  constructor({ baseUrl, responseType = 'json' }) {
    this.client = axios.create({
      responseType,
      baseURL: baseUrl,
    })
  }

  addAccessTokenToHeaders(getAccessToken, getNewAccessToken) {
    const requestInterceptor = config => {
      const accessToken = getAccessToken()

      if (accessToken) {
        const configWithAuth = {
          ...config,
          headers: {
            ...config.headers,
            Authorization: accessToken,
          },
        }
        return configWithAuth
      }

      return config
    }

    const requestErrorInterceptor = async error => {
      const originalRequest = error.config

      if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true
        const newAccessToken = await getNewAccessToken()
        axios.defaults.headers.common.Authorization = newAccessToken
        return this.client(originalRequest)
      }

      return Promise.reject(error)
    }

    this.client.interceptors.request.use(
      requestInterceptor,
      requestErrorInterceptor,
    )
  }
}

export default Http
